import React from "react";
import { useQuery } from "@apollo/client";

import HeaderRow from "./HeaderRow";
import TableContents from "./TableContents";
import LoadingSpinner from "core/LoadingSpinner";

import { apolloClient } from "js/apollo/apollo-client";
import { GET_ICON_ROYALTY_STATEMENTS } from "./queries";

const PoolRoyaltiesTable = ({ args }) => {
    const { data, loading } = useQuery(GET_ICON_ROYALTY_STATEMENTS, {
        variables: { username: args.username },
        client: apolloClient
    });

    const statements = data?.royaltyStatements?.statements || [];

    if (loading) return <LoadingSpinner />;

    if (!statements.length) return null;

    return (
        <table className="new">
            <HeaderRow />
            <TableContents statements={statements} />
        </table>
    );
};

export default PoolRoyaltiesTable;
